"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newFragmentField = newFragmentField;
const mobx_1 = require("mobx");
const utils_1 = require("../utils");
function newFragmentField(parentInstance, key) {
    // We always return the same `instance` field from our `value` method, but
    // we want to pretend that it's observable, so use a tick to force it.
    const _tick = (0, mobx_1.observable)({ value: 1 });
    // We steal the fragment from our parent, so that it doesn't
    // accidentally end up on the wire
    let value = parentInstance[key];
    delete parentInstance[key];
    const obj = {
        get value() {
            _tick.value > 0 || (0, utils_1.fail)();
            return value;
        },
        set value(v) {
            value = v;
            _tick.value++;
        },
    };
    return (0, mobx_1.makeAutoObservable)(obj, { value: false });
}
